import { FC, useContext, useState } from 'react';
import { ButtonBase, Chip } from '@mui/material';
import { useGetSmartResponses } from './useGetSmartResponses';
import { Carousel, createLocalTextMessage } from '@vs-online-only-app/ui';
import { useSelectedHeroConversation } from '../../../hooks/useSelectedHeroConversation';
import {
  AuthenticationContext,
  chatActions,
  useAppDispatch,
  useSendTextMessage,
} from '@vs-online-only-app/state';

const SmartResponses: FC = () => {
  const [sentMessages, setSentMessages] = useState<string[]>([]);

  const dispatch = useAppDispatch();
  const selectedHeroConversation = useSelectedHeroConversation();
  const sendTextMessageMutation = useSendTextMessage(selectedHeroConversation);
  const { user } = useContext(AuthenticationContext);
  const isArchived = Boolean(selectedHeroConversation?.archiveAttributes);
  const { smartResponses } = useGetSmartResponses(!isArchived).data || {};

  const handleSendMessage = (message: string) => {
    if (!selectedHeroConversation) return;

    const author = user?.username as string;
    const localTextMessage = createLocalTextMessage({
      conversationId: selectedHeroConversation.id,
      author,
      body: message,
    });
    dispatch(
      chatActions.addLocalMessage({
        conversationId: selectedHeroConversation.id,
        localMessage: localTextMessage,
      }),
    );
    sendTextMessageMutation.mutateAsync({
      messageBody: message,
      localMessageId: localTextMessage.sid,
    });
    setSentMessages([...sentMessages, message]);
  };

  if (!smartResponses || smartResponses.length === 0 || isArchived) {
    return null;
  }

  const unsentSmartResponses = smartResponses.filter(
    ({ smartResponse }) => !sentMessages.includes(smartResponse),
  );

  if (unsentSmartResponses.length === 0) {
    return null;
  }

  return (
    <Carousel>
      {unsentSmartResponses.map(({ smartResponse }) => (
        <ButtonBase
          style={{
            borderRadius: '100px',
          }}
          onClick={() => handleSendMessage(smartResponse)}
        >
          <Chip label={smartResponse} />
        </ButtonBase>
      ))}
    </Carousel>
  );
};

export default SmartResponses;
